import React, { useContext, useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import classNames from 'classnames';
import { toast, ToastContainer } from 'react-toastify';
import { Container } from 'react-bootstrap';
import AppContext from '../blanks/context/Context';
import NavbarTop from '../blanks/navbar/top/NavbarTop';
import NavbarVertical from '../blanks/navbar/vertical/NavbarVertical';
import Footer from '../blanks/footer/Footer';
import WindowsManager from '../windowsManager';

function MainLayout() {
  const { hash, pathname } = useLocation();
  const isKanban = pathname.includes('kanban');
  // const isChat = pathname.includes('chat');

  const {
    config: { isFluid, navbarPosition },
  } = useContext(AppContext);

  useEffect(() => {
    setTimeout(() => {
      if (hash) {
        const id = hash.replace('#', '');
        const element = document.getElementById(id);
        if (element) {
          element.scrollIntoView({ block: 'start', behavior: 'smooth' });
        }
      }
    }, 0);
  }, [hash]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <Container fluid={isFluid} className="px-1 px-md-3">
      {(navbarPosition === 'vertical' || navbarPosition === 'combo') && (
        <NavbarVertical />
      )}
      <div className={classNames('content d-flex flex-column vh-100', { 'pb-0': isKanban })}>
        <NavbarTop />

        {/* ------ Main Routes ------*/}

        <Outlet />
        <ToastContainer
          // className="position-relative"
          // icon={false}
          // closeButton={false}
          closeOnClick
          pauseOnHover
          position={toast.POSITION.BOTTOM_RIGHT}
        />
        <WindowsManager />
        <Footer />
      </div>
    </Container>
  );
}

export default MainLayout;
